import script from "./WebHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./WebHeader.vue?vue&type=script&setup=true&lang=js"

import "./WebHeader.vue?vue&type=style&index=0&id=29784cbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29784cbd"]])

export default __exports__